import React from 'react';
import { API_BASE } from '../config';

export default function BikeModal({ bike, show, onClose }) {
  if (!show || !bike) return null;

  const imageUrl = bike.image_url
    ? (bike.image_url.startsWith('http') ? bike.image_url : `${API_BASE}/${bike.image_url}`)
    : 'https://via.placeholder.com/400x300?text=No+Image';

  const waMsg = `Hi, I am interested in ${bike.title} (${bike.price}). ${
    bike.info ? 'Specs: ' + bike.info + '. ' : ''
  }${bike.description ? 'Details: ' + bike.description : ''}`;

  const enquiryUrl = `https://api.whatsapp.com/send?phone=919876543210&text=${encodeURIComponent(waMsg)}`;

  // Determine badge color
  let badgeClass = 'bg-success';
  if (bike.category === 'old') {
    badgeClass = 'bg-secondary';
  } else if (bike.category === 'offer') {
    badgeClass = 'bg-danger';
  }

  return (
    <div 
      className="modal show d-block" 
      tabIndex="-1" 
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content border-0 rounded-4 overflow-hidden shadow-lg">
          <div className="modal-body p-0">
            <div className="row g-0">
              <div className="col-md-6">
                <img 
                  src={imageUrl} 
                  className="w-100 h-100" 
                  style={{ objectFit: 'cover', minHeight: '300px' }} 
                  alt={bike.title}
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found'; }}
                />
              </div>
              <div className="col-md-6 p-4 p-lg-5 d-flex flex-column">
                <button 
                  type="button" 
                  className="btn-close ms-auto mb-2" 
                  onClick={onClose}
                  aria-label="Close"
                ></button>
                {bike.badge && (
                  <div className="mb-3">
                    <span className={`badge ${badgeClass} rounded-pill px-3 py-2`}>
                      {bike.badge}
                    </span>
                  </div>
                )}
                <h2 className="fw-bold mb-2">{bike.title}</h2>
                <h3 className="text-danger fw-bold fs-4 mb-3">{bike.price}</h3>
                {bike.info && (
                  <div className="text-muted fw-semibold mb-3">{bike.info}</div>
                )}
                <hr />
                <p 
                  className="mb-4 text-secondary" 
                  style={{ whiteSpace: 'pre-line' }}
                >
                  {bike.description || 'No additional description available.'}
                </p>
                <div className="mt-auto">
                  <a 
                    href={enquiryUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-warning w-100 py-3 fw-bold rounded-pill"
                  >
                    <i className="fab fa-whatsapp me-2"></i>Enquire on WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
